// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { cssInJS } from '../utils/styles';
import { CheckIcon } from '../icons';

export default class MenuItem extends React.Component {
  static propTypes = {
    style: PropTypes.instanceOf(Object),
    className: PropTypes.string,
    iconWidth: PropTypes.number,
    iconHeight: PropTypes.string,
    iconClass: PropTypes.instanceOf(Object),
    iconStyle: PropTypes.instanceOf(Object),
    label: PropTypes.string,
    current: PropTypes.bool,
    onClick: PropTypes.func,
  };

  render() {
    const { styles } = MenuItem;

    return (
      <a
        style={this.props.style}
        className={cx(this.props.className, styles.container, this.props.current && styles.dropdownItemCurrent)}
        onClick={this.handleClick}
      >
        {this.props.current && (<CheckIcon className={styles.menuIcon} width={14} style={{ fill: '#41403b' }} />)}
        {this.renderIcon()}
        {this.renderLabel()}
      </a>
    );
  }

  renderIcon() {
    if (!this.props.iconClass) {
      return null;
    }

    const { styles } = MenuItem;

    const IconType = this.props.iconClass;

    return (
      <IconType
        className={styles.icon}
        width={this.props.iconWidth}
        height={this.props.iconHeight}
        style={this.props.iconStyle}
      />
    );
  }

  renderLabel() {
    const { styles } = MenuItem;

    return this.props.label && <span className={styles.label}>{this.props.label}</span>;
  }

  handleClick = (event) => {
    event.stopPropagation();

    this.props.onClick(this);
  };
}

const styles = cssInJS({
  container: {
    color: '#41403b',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    padding: '5px 15px',
    margin: '2px 0',

    ':hover': {
      background: '#f4f4f4',
      color: '#41403b',
    },
  },

  dropdownItemCurrent: {
    background: '#f7f7f7',
  },

  icon: {
    width: 16,
    height: 16,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 8,
  },

  menuIcon: {
    width: 20,
    minWidth: 20,
    marginRight: 5,
    display: 'flex',
    justifyContent: 'center',
  },

  label: {
    fontSize: 13,
  },
});

MenuItem.styles = styles;
